<template lang="pug">
  .aml-report-details
    .aml-report-details__meta
      .aml-report-details__row
        span.aml-report-details__label Валюта
        span {{ currency }}
      .aml-report-details__row
        span.aml-report-details__label Адрес
        span.aml-report-details__break {{ report.address }}
      .aml-report-details__row
        span.aml-report-details__label Сервис
        span {{ provider }}
      .aml-report-details__row
        span.aml-report-details__label Проверено
        span {{ formatDate(report.checkedAt) }}
    .aml-report-details__score(:style="riskStyle(report.analysisRisk)")
      span Уровень риска
      strong {{ formatPercent(report.riskScore) }}
    .aml-report-details__analysis
      .aml-report-details__section-title Результаты анализа
      template(v-if="categoryGroups.length")
        .aml-report-details__group(
          v-for="group in categoryGroups"
          :key="group.risk"
        )
          .aml-report-details__group-title(:style="{ color: riskStyle(group.risk).color }")
            span.aml-report-details__dot(:style="{ backgroundColor: riskStyle(group.risk).color }")
            span {{ riskLabel(group.risk) }}
          .aml-report-details__category(
            v-for="category in group.categories"
            :key="`${group.risk}-${category.name}`"
          )
            span.aml-report-details__break {{ category.name }}
            strong {{ formatPercent(category.percent) }}
      .aml-report-details__empty(v-else) Категории не предоставлены
    .aml-report-details__recommendation(v-if="report.recommendation")
      .aml-report-details__section-title Что делать
      div {{ report.recommendation }}
    .aml-report-details__technical(v-if="showTechnical")
      .aml-report-details__row
        span.aml-report-details__label TxID
        span.aml-report-details__break {{ report.txid }}
      .aml-report-details__row
        span.aml-report-details__label Check ID
        span.aml-report-details__break {{ report.checkId }}
</template>

<script>
import {
  amlRiskLabel,
  amlRiskStyle,
  formatAmlDate,
  formatAmlPercent,
} from '@/utils/aml';

export default {
  name: 'AmlReportDetails',
  props: {
    report: {
      type: Object,
      required: true,
    },
    showTechnical: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    currency() {
      return this.report.network === 'bitcoin'
        ? 'BTC'
        : String(this.report.network || 'BTC').toUpperCase();
    },
    provider() {
      return String(this.report.provider || 'bitok').toLowerCase() === 'bitok'
        ? 'BitOK'
        : this.report.provider;
    },
    categoryGroups() {
      const groups = { high: [], medium: [], low: [] };
      (this.report.categories || [])
        .filter((category) => Number(category.percent) > 0)
        .forEach((category) => {
          const risk =
            category.group === 'high'
              ? 'high'
              : category.group === 'low'
                ? 'low'
                : 'medium';
          groups[risk].push(category);
        });
      return ['high', 'medium', 'low']
        .filter((risk) => groups[risk].length)
        .map((risk) => ({
          risk,
          categories: groups[risk].sort(
            (left, right) => Number(right.percent) - Number(left.percent),
          ),
        }));
    },
  },
  methods: {
    formatDate: formatAmlDate,
    formatPercent: formatAmlPercent,
    riskLabel: amlRiskLabel,
    riskStyle: amlRiskStyle,
  },
};
</script>

<style scoped>
.aml-report-details {
  color: #303133;
  font-size: 13px;
  line-height: 1.45;
  text-align: left;
}

.aml-report-details__meta,
.aml-report-details__analysis,
.aml-report-details__recommendation,
.aml-report-details__technical {
  padding: 10px 0;
  border-bottom: 1px solid #ebeef5;
}

.aml-report-details__technical {
  border-bottom: 0;
}

.aml-report-details__row,
.aml-report-details__category {
  display: grid;
  grid-template-columns: 86px minmax(0, 1fr);
  gap: 10px;
  margin: 4px 0;
}

.aml-report-details__category {
  grid-template-columns: minmax(0, 1fr) auto;
  padding-left: 16px;
}

.aml-report-details__label,
.aml-report-details__empty {
  color: #909399;
}

.aml-report-details__score {
  display: flex;
  justify-content: space-between;
  gap: 16px;
  margin-top: 10px;
  padding: 8px 10px;
  border: 1px solid;
  border-radius: 4px;
}

.aml-report-details__section-title,
.aml-report-details__group-title {
  margin-bottom: 7px;
  font-weight: 600;
}

.aml-report-details__group {
  margin-top: 9px;
}

.aml-report-details__group-title {
  display: flex;
  align-items: center;
  gap: 7px;
}

.aml-report-details__dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
}

.aml-report-details__break {
  overflow-wrap: anywhere;
}
</style>
